import { AsyncPipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { BehaviorSubject, takeUntil, Observable } from 'rxjs';

@Component({
  selector: 'add-button',
  templateUrl: './add-button.component.html',
  standalone: true,
  imports: [ButtonModule, PopoverModule, TranslateModule, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddButtonComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null); // expected data ["edit","active","inactive"] etc

  readonly onAction = output<{ action: string; columnData: any }>();

  showButton = true;
  ngOnInit(): void {
    this.columnData.subscribe({
      next: (cData: any) => {
        this.showButton =
          cData?.trial_type == 'ClassBased' &&
          cData?.status.toLowerCase() == 'active' &&
          this.isAllClassBased(cData);
      },
    });
  }

  isAllClassBased(data: any) {
    if (data.trial_booking) {
      return (
        data.trial_booking.filter(
          (o: any) =>
            o.BookingStatus.toLowerCase() !== 'cancelled' &&
            o.BookingStatus.toLowerCase() !== 'noshow' &&
            o.BookingStatus.toLowerCase() !== 'completed',
        ).length <= data.available_trials
      );
    } else {
      return true;
    }
  }

  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData: columnData });
  }
}
